import React from "react";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";

import { useNavigate } from "react-router-dom";

import BackIcon from "../../../../assets/svg/BackIcon";
import EvolutionGames from "../../../../assets/images/provider/provider-logo-evolution.png";
import EzugiGames from "../../../../assets/images/provider/provider-logo-ezugi.png";
import AppuGames from "../../../../assets/images/provider/Supernowa.jpg";

const LiveDealer = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div>
        <HeaderAfterLogin />
      </div>

      <main className="main">
        <div className="container">
          <div className="live-deal-section">
            <div className="d-flex justify-content-between  HeadingSection align-items-center mt-3 mb-3">
              <h2 className="sectionTitle border-0">Live Casino</h2>
              <div className="back-link" onClick={() => navigate(-1)}>
                Back <BackIcon />
              </div>
            </div>
            <ul>
              <li>
                <a href="/casino/evolution">
                  <img src={EvolutionGames} alt="Providers Logo" />
                </a>
              </li>
              <li>
                <a href="/casino/ezugi">
                  <img src={EzugiGames} alt="Providers Logo" />
                </a>
              </li>
              <li>
                <a href="/casino/supernowa">
                  <img src={AppuGames} alt="Providers Logo" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </main>

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default LiveDealer;
